const IS_LOADING = "lists/playlist_templates/IS_LOADING";
const IS_PARTIAL_LOADING = "lists/playlist_templates/IS_PARTIAL_LOADING";
const IS_ERROR = "lists/playlist_templates/IS_ERROR";
const DATA = "lists/playlist_templates/DATA";

export { IS_LOADING, IS_PARTIAL_LOADING, IS_ERROR, DATA };
